import Vue from 'vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

// Retorna os cadastros individuais todos de uma equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getCadastrosIndividuaisTodosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await Vue.prototype.$api.get(
      `/app/pos-covid-19/equipe/${cod_ibge}/${nu_ine}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna o nome da cor para pintar a linha da tabela
/**
 *
 */
export function printTableRow(item) {
  if (item.dt_obito != null && item.saiu != '1') {
    return 'red'
  } else {
    return 'green'
  }
}

export function exibirVermelhos(cadastros) {
  let filtro = cadastros.filter((item) => {
    if (item.dt_obito != null && item.saiu != '1') {
      return true
    } else {
      return false
    }
  })
  return filtro
}

export function exibirVerdes(cadastros) {
  let filtro = cadastros.filter((item) => {
    if (item.dt_obito != null && item.saiu != '1') {
      return false
    } else {
      return true
    }
  })
  return filtro
}

export function generatePdf(
  cadastros,
  selectEquipe,
  selectProfissional,
  nomeProfissional
) {
  let title_pdf = 'Pós Covid-19'
  let titlePdfSave = utils.methods.titlePdf(
    'Pós Covid-19',
    selectEquipe.no_equipe
  )

  let description_pdf = 'Registro de atendimento a pessoas pós covid'
  let headers_pdf = [
    'PROFISSIONAL',
    'NOME',
    'NASCIMENTO',
    'MÃE',
    'MA',
    'ÚLTIMO ATENDIMENTO COVID',
    'ATENDIMENTO',
    'PROCEDIMENTO',
    'Pós covid',
    'DOCUMENTO',
  ]
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.no_profissional = cadastros[i].no_profissional
    obj.no_cidadao = cadastros[i].no_cidadao
    obj.dt_nascimento = utils.methods.formatDate(cadastros[i].dt_nascimento)
    obj.no_mae = cadastros[i].no_mae
    obj.micro_area = cadastros[i].micro_area
    obj.dt_ultimo_atend_covid = utils.methods.formatDate(
      cadastros[i].dt_ultimo_atend_covid
    )
    obj.dt_atendimento = utils.methods.formatDate(cadastros[i].dt_atendimento)
    obj.dt_proced_pos_covid = utils.methods.formatDate(
      cadastros[i].dt_proced_pos_covid
    )
    obj.pos_covid = cadastros[i].pos_covid
      ? cadastros[i].pos_covid === '0'
        ? 'Não'
        : 'Sim'
      : ''
    let documentoText = ''
    let lineBreak = ''
    if (cadastros[i].cpf !== null && cadastros[i].cpf !== undefined) {
      lineBreak = '\n'
      documentoText += `CPF ${cadastros[i].cpf}`
    }
    if (cadastros[i].cns !== null && cadastros[i].cns !== undefined) {
      documentoText += `${lineBreak}CNS ${cadastros[i].cns}`
    }
    obj.documento = documentoText
    data_pdf.push(obj)
  }
  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )
      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.nu_ine,
          },
          {
            label: 'Profissional ACS',
            value: nomeProfissional,
          },
        ],
        verticalPosition
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          // pinta a cor da descrição das colunas de preto
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}
